import ApiOptions from '@/datatypes/api-options';

export default class ApiGetOptions extends ApiOptions {
  constructor(options) {
    super(options);

    this.method = 'get';
  }
}
